import { render } from "./_Duplicar.vue?vue&type=template&id=b2460b6c"
import script from "./_Duplicar.vue?vue&type=script&lang=ts"
export * from "./_Duplicar.vue?vue&type=script&lang=ts"
script.render = render

export default script